export const WIZARD_STEP_KEYS = [
  'campaignForm.step.basics',
  'campaignForm.step.targeting',
  'campaignForm.step.review',
] as const;

export type WizardStep = 1 | 2 | 3;

export const LAST_STEP: WizardStep = 3;

export function readStep(params: URLSearchParams): WizardStep {
  const parsed = Number.parseInt(params.get('step') ?? '1', 10);
  if (!Number.isFinite(parsed)) return 1;
  return Math.min(LAST_STEP, Math.max(1, parsed)) as WizardStep;
}
